import { z } from 'zod';

/**
 * Préférences du joueur (son, vibration), rangées en `localStorage`.
 *
 * Comme la progression, c'est une donnée NON FIABLE : elle est validée par
 * zod à la lecture, et un contenu corrompu retombe sur les valeurs par défaut.
 */
export const SettingsSchema = z.object({
  sound: z.boolean().default(true),
  haptics: z.boolean().default(true),
});

export type Settings = z.infer<typeof SettingsSchema>;

export const DEFAULT_SETTINGS: Settings = Object.freeze({ sound: true, haptics: true });
